module.exports = __webpack_public_path__ + "a616a8839cba886bc193eca163ee88c4.png";